/**
 * Size Guide Modal - Gestion du modal de guide des tailles
 */

function closeTaille() {
  const overlay = document.getElementById('bgtaille');
  const modal = document.getElementById('taille');
  
  if (overlay) overlay.classList.remove('open');
  if (modal) modal.classList.remove('open');
  
  // Empêcher le scroll du body
  document.body.style.overflow = '';
}

function openTaille() {
  const overlay = document.getElementById('bgtaille');
  const modal = document.getElementById('taille');
  const steps = document.querySelectorAll('.size-guide-step');
  
  // Réinitialiser à l'étape 1
  steps.forEach(step => step.classList.remove('openbloctext'));
  const step1 = document.getElementById('taille1');
  if (step1) step1.classList.add('openbloctext');
  
  if (overlay) overlay.classList.add('open');
  if (modal) modal.classList.add('open');
  
  // Empêcher le scroll du body
  document.body.style.overflow = 'hidden';
}

function etapeSuiv(suiv) {
  const steps = document.querySelectorAll('.size-guide-step');
  steps.forEach(step => step.classList.remove('openbloctext'));
  
  const nextStep = document.getElementById('taille' + suiv);
  if (nextStep) {
    nextStep.classList.add('openbloctext');
    // Scroll vers le haut du modal
    const modal = document.getElementById('taille');
    if (modal) {
      modal.scrollTop = 0;
    }
  }
}

function etapePrecedent(prec) {
  etapeSuiv(prec);
}

function getTaillebasValue() {
  return document.querySelector('input[name="taillebas"]:checked')?.value;
}

function getTaillesoutienValue() {
  return document.querySelector('input[name="taillesoutien"]:checked')?.value;
}

/** Étape 1 → hanches seulement si « Je ne sais pas » pour la taille de bas */
function etapeSuivDepuis1() {
  const v = getTaillebasValue();
  if (v === '0') {
    etapeSuiv(2);
  } else {
    etapeSuiv(3);
  }
}

/** Retour depuis la hauteur : hanches ou taille de bas selon le parcours */
function etapePrecedentDepuisHauteur() {
  const v = getTaillebasValue();
  if (v === '0') {
    etapeSuiv(2);
  } else {
    etapeSuiv(1);
  }
}

/** Après soutien-gorge : poitrine seulement si « Je ne sais pas », sinon résultat */
function etapeSuivDepuisSoutien() {
  const v = getTaillesoutienValue();
  if (v === '0') {
    etapeSuiv(6);
  } else {
    selectionTaille(7);
  }
}

/** Retour depuis le résultat : poitrine ou soutien-gorge selon le parcours */
function etapePrecedentDepuisResultat() {
  const v = getTaillesoutienValue();
  if (v === '0') {
    etapeSuiv(6);
  } else {
    etapeSuiv(4);
  }
}

function selectionTaille(suiv) {
  etapeSuiv(suiv);
  
  const taillebasVal = getTaillebasValue() || '';
  const taillesoutienVal = getTaillesoutienValue() || '';
  
  // Récupérer les valeurs du formulaire (hanches / poitrine ignorées si étape non parcourue)
  const formValues = {};
  formValues['taillebas'] = taillebasVal;
  formValues['taillehanche'] = document.querySelector('input[name="taillehanche"]:checked')?.value || '';
  formValues['taillehaut'] = document.querySelector('input[name="taillehaut"]:checked')?.value || '';
  formValues['taillesoutien'] = taillesoutienVal;
  formValues['taillepoitrine'] = document.querySelector('input[name="taillepoitrine"]:checked')?.value || '';
  
  // Tableau de correspondances (sans tour de dos — étape retirée)
  const taillesTable = {
    36: {
      taillebas: '1',
      taillehanche: '2',
      taillehaut: '1',
      taillebonnet: '85A-85B-90A',
      taillepoitrine: '1',
    },
    38: {
      taillebas: '2',
      taillehanche: '3',
      taillehaut: '1',
      taillebonnet: '85C-90B',
      taillepoitrine: '2',
    },
    40: {
      taillebas: '3',
      taillehanche: '4',
      taillehaut: '2',
      taillebonnet: '85D-90C-95A-95B',
      taillepoitrine: '3',
    },
    42: {
      taillebas: '4',
      taillehanche: '5',
      taillehaut: '2',
      taillebonnet: '90D-95C',
      taillepoitrine: '4',
    },
  };
  
  // Mapper les valeurs de soutien-gorge
  const soutienMapping = {
    '1': '85A', '2': '85B', '3': '85C', '4': '85D', '5': '85E',
    '6': '85A', '7': '85B', '8': '85C', '9': '85D', '10': '85E',
    '11': '90A', '12': '90B', '13': '90C', '14': '90D', '15': '90E',
    '16': '95A', '17': '95B', '18': '95C', '19': '95D', '20': '95E',
  };
  
  const results = [];
  
  // Comparer les valeurs du formulaire avec le tableau
  for (const formKey in formValues) {
    if (formValues[formKey] === '0' || formValues[formKey] === '') continue;
    // Hanches : seulement si l'utilisateur est passé par l'étape (taille de bas = je ne sais pas)
    if (formKey === 'taillehanche' && taillebasVal !== '0') continue;
    // Poitrine : seulement si soutien-gorge = je ne sais pas
    if (formKey === 'taillepoitrine' && taillesoutienVal !== '0') continue;
    
    for (const tableKey in taillesTable) {
      const tableEntry = taillesTable[tableKey];
      
      if (formKey === 'taillesoutien') {
        // Gestion spéciale pour le soutien-gorge
        const selectedSoutien = soutienMapping[formValues[formKey]];
        if (selectedSoutien && tableEntry.taillebonnet.includes(selectedSoutien)) {
          results.push(tableKey);
        }
      } else if (tableEntry[formKey] === formValues[formKey]) {
        results.push(tableKey);
      }
    }
  }
  
  // Trouver la taille idéale (la plus fréquente)
  const tailleideale = getMaxOccurrence(results);
  
  // Afficher le résultat
  const tailleIdealeElement = document.getElementById('tailleideale');
  if (tailleIdealeElement) {
    tailleIdealeElement.textContent = tailleideale || 'X';
  }
  
  // Générer l'URL de sélection
  const lang = document.documentElement.lang || 'fr';
  let urlselection;
  
  if (lang === 'fr') {
    urlselection = `/${lang}/collections/les-femmes?filter.p.m.custom.taille=${tailleideale}`;
  } else {
    urlselection = `/${lang}/collections/women?filter.p.m.custom.taille=${tailleideale}`;
  }
  
  // Mettre à jour le lien de sélection
  const urlSelectionElement = document.getElementById('urlselection');
  if (urlSelectionElement) {
    urlSelectionElement.setAttribute('href', urlselection);
  }
}

function getMaxOccurrence(arr) {
  if (!arr || arr.length === 0) return null;
  
  const o = {};
  let maxCount = 0;
  let maxValue = null;
  
  for (let i = 0; i < arr.length; i++) {
    const m = arr[i];
    
    if (!o.hasOwnProperty(m)) {
      o[m] = 0;
    }
    ++o[m];
    
    if (o[m] > maxCount) {
      maxCount = o[m];
      maxValue = m;
    }
  }
  
  return maxValue;
}

// Initialisation au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
  // Fermer le modal en cliquant sur l'overlay
  const overlay = document.getElementById('bgtaille');
  if (overlay) {
    overlay.addEventListener('click', closeTaille);
  }
  
  // Fermer le modal avec la touche Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const modal = document.getElementById('taille');
      if (modal && modal.classList.contains('open')) {
        closeTaille();
      }
    }
  });
  
  // Exposer les fonctions globalement pour les liens
  window.closeTaille = closeTaille;
  window.openTaille = openTaille;
  window.etapeSuiv = etapeSuiv;
  window.etapePrecedent = etapePrecedent;
  window.etapeSuivDepuis1 = etapeSuivDepuis1;
  window.etapePrecedentDepuisHauteur = etapePrecedentDepuisHauteur;
  window.etapeSuivDepuisSoutien = etapeSuivDepuisSoutien;
  window.etapePrecedentDepuisResultat = etapePrecedentDepuisResultat;
  window.selectionTaille = selectionTaille;
});

// Exposer les fonctions globalement
window.closeTaille = closeTaille;
window.openTaille = openTaille;
window.etapeSuiv = etapeSuiv;
window.etapePrecedent = etapePrecedent;
window.etapeSuivDepuis1 = etapeSuivDepuis1;
window.etapePrecedentDepuisHauteur = etapePrecedentDepuisHauteur;
window.etapeSuivDepuisSoutien = etapeSuivDepuisSoutien;
window.etapePrecedentDepuisResultat = etapePrecedentDepuisResultat;
window.selectionTaille = selectionTaille;

